import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  campaignContainer: {
    padding: '2% 4%',
  },
  campaignContainerWidth: {
    padding: '2% 4%',
    height: `100%`,
    overflowX: 'auto',
  },
  previewChip: {
    minWidth: 160,
    maxWidth: 210,
  },
  dropZoneContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    maxHeight: '500px',
  },
  powerBi: {
    verticalAlign: 'middle',
  },
  download: {
    float: 'right',
    paddingTop: '7px',
  },
  biContainer: {
    paddingTop: '20px',
    verticalAlign: 'sub',
  },
  uploadContainer: {
    display: 'flex',
    alignItems: 'center',
    '& button': {
      marginLeft: 'auto',
    },
    '& p': {
      marginRight: 'auto',
      paddingLeft: '3px',
    },
  },
}));

export default useStyles;
